/* eslint-disable react/jsx-no-bind */
import { makeStyles, Typography } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import CountyContext from '../../contexts/CountyContext';
import StoryContext from '../../contexts/StoryContext';
import { displayChildAge, displayFacilityType, displayFamilyType } from '../../modules/data';
import { rdsSelect } from '../../modules/rds';
import { stateFIPS } from '../../modules/states';
import { toPercent } from '../../modules/text';
import ResponsiveContainer from '../ResponsiveContainer';
import StateCountyMap from '../StateCountyMap';


function CountyMapHome() {
  const { stateCode } = useParams();
  const {
    primaryColor, lightColor, darkColor, selectionColor, hoverColor,
  } = useContext(StoryContext);
  const {
    county,
  } = useContext(CountyContext);
  const [, setReady] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);

  const classes = makeStyles(() => ({
    container: {
      margin: 'auto',
    },
  }))();



  useEffect(() => {
    setError(null);
    setReady(false);

    // const server = new RdsServer(process.env.REACT_APP_RDS_SERVER);
    // Instantiate a catalog that exists on the server
    // const catalog = new RdsCatalog(server, '3rdparty');
    // Instantiate a data product that exists on the catalog
    // const dataProduct = new RdsDataProduct(catalog, 'acs_sams_county_wide');
    const whereClause = `state_fips=${stateFIPS[stateCode.toUpperCase()]} AND (county_suppressed=0 OR county_suppressed=NULL)`;
    rdsSelect('3rdparty', 'acs_sams_county_wide', {
      cols: 'county_fips,prop_struct_before_1980b',
      where: whereClause,
      format: 'amcharts',
      inject: false,
      orderby: 'county_fips',
      limit: 500,
    })
      .then((result) => {
        const d = result.parsedBody.dataProvider;
        const payload = d.map((v) => Object.assign(v, { value: v.prop_struct_before_1980b }));
        setData(payload);
      })
      .catch((rdsError) => {
        setError(rdsError);
      })
      .finally(() => {
        setReady(true);
      });
  }, [stateCode]);

  const toolTipFormatterFunction = function toolTipFormatterFunction(d, payload) {
    if (!payload) {
      return 'No data';
    }
    return `In <b>${d.properties.name} ${d.properties.TYPE}</b>, <b>${toPercent(payload.value)}</b> of children live in homes built before 1979`;
  };

  const legendValueFormatter = function legendValueFormatter(v) {
    return Number.parseInt(v, 10);
  };

  const legendLabelFormatter = function legendLabelFormatter(v) {
    return toPercent(v);
  };

  return (
    <>
      {error && <Typography variant="body1" color="error">{error.message}</Typography>}
      <ResponsiveContainer aspect={1.2} width="70%" className={classes.container}>
        <StateCountyMap
          data={data}
          stateCode={stateCode}
          legendValueFormatter={legendValueFormatter}
          legendLabelFormatter={legendLabelFormatter}
          legendTitleText="The darker the color, the greater the percent of children who live in homes built before 1979"
          colorHigh={darkColor}
          colorLow={lightColor}
          primaryColor={primaryColor}
          selectionColor={selectionColor}
          hoverColor={hoverColor}
          // setCounty={setCounty}
          // setCountyCode={setCountyCode}
          // setCountyData={setCountyData}
          county={county}
          displayFacilityType={displayFacilityType}
          displayFamilyType={displayFamilyType}
          displayChildAge={displayChildAge}
          toolTipFormatterFunction={toolTipFormatterFunction}
        />
      </ResponsiveContainer>
    </>
  );
}

export default CountyMapHome;
